import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { paragraphRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type ParagraphProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    type: 'vertical' | 'horizontal'
    alignment: 'left' | 'right' | 'center'
    title: string
    subtitle: string
    text: string
  }>

const Paragraph = ({ type, alignment, title, subtitle, text, ...props }: ParagraphProps) => {
  return (
    <Motion animation={paragraphRevealAnimation}>
      <Section {...props}>
        <Container>
          <Grid className="gap-spacing-md md:gap-spacing-lg">
            <div
              className={cn(
                'col-span-4 flex flex-col gap-spacing-sm md:col-span-6',
                type === 'vertical' && 'sm lg:col-span-8',
                type === 'vertical' && alignment === 'right' && 'lg:col-start-5',
                type === 'vertical' && alignment === 'center' && 'lg:col-start-3',
                type === 'horizontal' && 'lg:col-span-3',
                type === 'horizontal' && alignment === 'right' && 'lg:order-1 lg:col-start-10'
              )}
            >
              <Typography variant="h5">{title}</Typography>
              <Typography variant="large" className="font-medium text-text-accent-light-dark">
                {subtitle}
              </Typography>
            </div>
            <div
              className={cn(
                'col-span-4 mb-spacing-sm md:col-span-6',
                type === 'vertical' && 'lg:col-span-8',
                type === 'vertical' && alignment === 'right' && 'lg:col-start-5',
                type === 'vertical' && alignment === 'center' && 'lg:col-start-3',
                type === 'horizontal' && 'lg:col-span-7',
                type === 'horizontal' && alignment === 'left' && 'lg:col-start-5',
                type === 'horizontal' && alignment === 'right' && 'lg:-order-1 lg:col-start-2'
              )}
            >
              <Typography variant="regular">{text}</Typography>
            </div>
          </Grid>
        </Container>
      </Section>
    </Motion>
  )
}

export default Paragraph
